"use strict";
// TIMECODE UTILS
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFrameToTimecode = exports.timecodeToSeconds = exports.timecodeToString = exports.parseStringToTimecode = void 0;
function timecodeToSeconds(timecode) {
    return timecode.hours * 3600 + timecode.minutes * 60 + timecode.seconds + timecode.frames / timecode.framerate;
}
exports.timecodeToSeconds = timecodeToSeconds;
function SecondsToTimecode() { }
function RebalanceTimecode() { }
// Function returns in an object of string
// the parsed timecode, this is used in MIDI.vue
//
function parseStringToTimecode(string, framerate) {
    return {
        hours: parseInt(string.substring(0, 2)),
        minutes: parseInt(string.substring(3, 5)),
        seconds: parseInt(string.substring(6, 8)),
        frames: parseInt(string.substring(9, 11)),
        framerate: framerate || 24,
    };
}
exports.parseStringToTimecode = parseStringToTimecode;
// for UI, adds a frame to the current MIDI Value
function addFrameToTimecode(timecode) {
    timecode.frames += 1;
    if (timecode.frames >= timecode.framerate) {
        timecode.frames = 0;
        timecode.seconds += 1;
    }
    if (timecode.seconds >= 60) {
        timecode.seconds = 0;
        timecode.minutes += 1;
    }
    if (timecode.minutes >= 60) {
        timecode.minutes = 0;
        timecode.hours += 1;
    }
    if (timecode.hours >= 24) {
        timecode.hours = 0;
    }
    return timecode;
}
exports.addFrameToTimecode = addFrameToTimecode;
function timecodeToString(timecode) {
    return `${timecode.hours}:${timecode.minutes}:${timecode.seconds}:${timecode.frames}`;
}
exports.timecodeToString = timecodeToString;
